import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FilePdf } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/Seo";
import { SnapshotView } from "@/components/SnapshotView";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/fers";
import { exportSnapshotPdf } from "@/lib/snapshotPdf";

export default function SharedSnapshot() {
  const { token } = useParams();
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/shared/snapshot/${token}`).then((r) => setDoc(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);
  if (err) return <div className="glass p-8 max-w-xl" data-testid="shared-snapshot-error"><Seo title="Shared retirement snapshot" path="/shared" noindex /><p className="font-display text-xl font-semibold">Link not available</p><p className="text-sm text-muted-foreground mt-2">{err}</p></div>;
  if (!doc) return <p className="text-sm text-muted-foreground">Loading...</p>;
  return (
    <div className="max-w-5xl fade-up" data-testid="shared-snapshot">
      <Seo title="Shared retirement snapshot" path="/shared" noindex />
      <p className="text-xs uppercase tracking-widest text-cyan-700 dark:text-cyan-400">Read-only shared view</p>
      <div className="flex flex-wrap items-end justify-between gap-4 mt-2 mb-8">
        <div>
          <h1 className="text-4xl sm:text-5xl font-semibold text-grad-head" data-testid="shared-snapshot-title">{doc.first_name}'s retirement snapshot</h1>
          <p className="text-sm text-muted-foreground mt-3" data-testid="shared-snapshot-meta">Numbers as of {fmtDate(new Date(doc.created_at))} · link active until {fmtDate(new Date(doc.expires_at))}</p>
        </div>
        <Button variant="outline" className="rounded-full" onClick={() => exportSnapshotPdf(doc.data, doc.first_name)} data-testid="shared-snapshot-pdf-button"><FilePdf size={16} className="mr-1.5" />Download PDF</Button>
      </div>
      <SnapshotView d={doc.data} />
      <p className="text-xs text-muted-foreground mt-6 max-w-3xl">Plan: {doc.data.plan_label}. These are estimates in future dollars based on {doc.first_name}'s own profile and assumptions, not an official OPM, SSA or TSP statement, and not financial advice.</p>
    </div>
  );
}
